import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import InvoiceDoc from '../models/InvoiceDoc';
import { BiDownload } from 'react-icons/bi';
import { FaRecycle } from 'react-icons/fa';
import InvoiceType from '../models/InvoiceType';

interface IInvoiceDocumentManagementDialogProps {
    dialogName: string;
    getBaseCSV?: (invoiceNumber: string) => void;
    createNewTimesheet?: () => void;
    getExpenseReceipts?: (invoiceNumber: number, isManual: boolean) => void;
    veiwExpenseReceipts?: (invoiceNumber: number) => void;
    mergeDocuments?: (docsToMerge: Array<InvoiceDoc>, invoiceNumber: string) => void;
    addDocument?: () => void;
    deleteDocument?: (documentId: number, isArchived: boolean) => void;
    createDocument?: (documentType: number, invoiceNumber: string) => void;
    downloadDocument?: (doc: InvoiceDoc) => void;
    handleConfirm?: (refresh: boolean) => void;
    hideDialog: () => void;
    invoiceNumber?: string;
    invoiceGroupNumber?: string;
    documentList?: Array<InvoiceDoc>;
    igDocumentList?: Array<InvoiceDoc>;
    archivedDocumentList?: Array<InvoiceDoc>;
    refreshInvoiceList?: () => void;
    invoiceTypes?: Array<InvoiceType>;
    setGeneratingDocument?: (generating: boolean) => void;
    generatingDocument?: boolean;
    userIsAdmin?: boolean;
}

const InvoiceDocumentManagementDialog = (props: IInvoiceDocumentManagementDialogProps) => {
    const [selectedDocs, setSelectedDocs] = useState<InvoiceDoc[]>([]);
    const [documentDisplayList, setDocumentDisplayList] = useState<InvoiceDoc[]>([]);

    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (Array.isArray(props?.documentList)) {
            setDocumentDisplayList(props.documentList);
        } else if (Array.isArray(props?.igDocumentList)) {
            setDocumentDisplayList(props.igDocumentList);
        }
    }, [props?.documentList, props?.igDocumentList]);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const OKClicked = () => {
        props.handleConfirm(true);
    };

    const handleCheckboxChange = (doc: InvoiceDoc, checked: boolean) => {
        setSelectedDocs((prev) => {
            if (checked) {
                // Add to selection (avoid duplicates)
                return prev.some((d) => d.id === doc.id) ? prev : [...prev, doc];
            } else {
                // Remove from selection
                return prev.filter((d) => d.id !== doc.id);
            }
        });
    };

    const handleSelectAll = (allDocs: InvoiceDoc[]) => {
        setSelectedDocs(allDocs);
    };

    const handleDeselectAll = () => {
        setSelectedDocs([]);
    };

    const handleDeleteDocument = (docId: number, archived: boolean) => {
        props?.deleteDocument(docId, archived);
        if (!!props?.refreshInvoiceList) {
            props?.refreshInvoiceList();
        }
    };

    const getDocumentDescription = (docType: string) => {
        let documentDescription = '';
        if (props?.invoiceNumber && Array.isArray(props.invoiceTypes) && props.invoiceTypes.length > 0) {
            const doc = props.invoiceTypes.find((it) => {
                return it.documentType === docType;
            });
            if (doc) {
                documentDescription = doc.description;
            }
        } else if (props?.invoiceGroupNumber && Array.isArray(props.invoiceTypes) && props.invoiceTypes.length > 0) {
            const doc = props.invoiceTypes.find((it) => {
                return it.documentType === docType;
            });
            if (doc) {
                documentDescription = doc.description;
            }
        }
        return documentDescription;
    };

    const getDialogTitle = () => {
        if (props?.documentList) {
            return 'Manage Invoice Documents';
        } else if (props?.igDocumentList) {
            return 'Manage Invoice Group Documents';
        }
        return 'Manage Documents';
    };

    const displayDocuments = () => {
        return (
            <>
                <div style={{overflowX: 'hidden'}}>
                {documentDisplayList.map((doc: InvoiceDoc, index: number) => (
                    <tr
                        key={index}
                        className="table-item-hover"
                        style={{
                            backgroundColor: '',
                            textAlign: 'center'
                        }}
                    >
                        <td style={{ width: '2%' }}>
                            <input
                                type={'checkbox'}
                                onChange={(e) => handleCheckboxChange(doc, e.target.checked)}
                                checked={selectedDocs.some((d) => d.id === doc.id)}
                            />
                        </td>
                        <td style={{ width: '20%' }}>
                            {getDocumentDescription(doc.documentType)}
                        </td>
                        <td style={{ width: '20%' }}>
                            {new Date(!!doc?.fileDate ? doc.fileDate : '').toLocaleDateString()}
                        </td>
                        <td style={{ width: '20%' }}>
                            {doc.fileSize}
                        </td>
                        <td style={{ width: '8%' }}>
                            {!!doc?.source ? doc.source === 'C' ? 'Generated' : 'Manual' : 'Unknown'}
                        </td>
                        <td style={{ width: '10%' }}>
                            {doc.documentType}
                        </td>
                        <td style={{ width: '5%' }}>
                            <Button
                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                text={''}
                                title="Download"
                                reactIcon={BiDownload}
                                iconHoverColor="blue"
                                iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                onClick={() => props?.downloadDocument(doc)}
                            />
                        </td>
                        <td style={{ width: '5%' }}>
                            <Button
                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                text={''}
                                title="Delete"
                                reactIcon={FaRecycle}
                                iconHoverColor="blue"
                                iconStyle={{fill: 'rgb(237, 53, 36)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                onClick={() => {
                                    handleDeleteDocument(doc.id, false);
                                }}
                            />
                        </td>
                    </tr>
                ))}
                </div>
            </>
        );
    };

    const displayArchivedDocuments = () => {
        return (
            <>
                <div style={{overflowX: 'hidden'}}>
                {props?.archivedDocumentList?.map((doc: InvoiceDoc, index: number) => (
                    <tr
                        key={index}
                        className="table-item-hover"
                        style={{
                            backgroundColor: '',
                            textAlign: 'center'
                        }}
                    >
                        <td style={{ width: '10%' }}>
                            {getDocumentDescription(doc.documentType)}
                        </td>
                        <td style={{ width: '10%' }}>
                            {new Date(!!doc?.fileDate ? doc.fileDate : '').toLocaleDateString()}
                        </td>
                        <td style={{ width: '10%' }}>
                            {doc.fileSize}
                        </td>
                        <td style={{ width: '8%' }}>
                            {!!doc?.source ? doc.source === 'C' ? 'Generated' : 'Manual' : 'Unknown'}
                        </td>
                        <td style={{ width: '10%' }}>
                            {doc.documentType}
                        </td>
                        <td style={{ width: '10%', whiteSpace: 'nowrap' }}>
                            {doc.archivedBy}
                        </td>
                        <td style={{ width: '10%' }}>
                            {new Date(!!doc?.archivedDate ? doc.archivedDate : '').toLocaleDateString()}
                        </td>
                        <td title={doc.archiveReason} style={{ width: '10%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {doc.archiveReason}
                        </td>
                        <td style={{ width: '5%' }}>
                            <Button
                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                text={''}
                                title="Download"
                                reactIcon={BiDownload}
                                iconHoverColor="blue"
                                iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                onClick={() => props?.downloadDocument(doc)}
                            />
                        </td>
                        {props?.userIsAdmin && <td style={{ width: '5%' }}>
                            <Button
                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                text={''}
                                title="Delete"
                                reactIcon={FaRecycle}
                                iconHoverColor="blue"
                                iconStyle={{fill: 'rgb(237, 53, 36)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                onClick={() => {
                                    handleDeleteDocument(doc.id, true);
                                }}
                            />
                        </td>}
                    </tr>
                ))}
                </div>
            </>
        );
    };

    return (
        <Dialog title={getDialogTitle()} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '50%' }}>
            <div style={{ display: 'flex', justifyContent: 'left', width: '100%'}}>
                <form style={{width: '100%'}}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <label>
                            {props?.documentList && <label>Invoice #:<span style={{fontWeight: 'bold', fontSize: '15px'}}>{` ` + (props?.invoiceNumber ? props.invoiceNumber : '')}</span></label>}
                            {props?.igDocumentList && <label>
                                Invoice Group #:
                                <span
                                    style={{fontWeight: 'bold', fontSize: '15px'}}
                                >
                                    {` ` + (props?.invoiceGroupNumber ? props.invoiceGroupNumber : '')}
                                </span>
                            </label>}
                        </label>
                        {/* .project-billing's own table CSS sets display:block, which breaks the
                            browser's normal table column-alignment (see VendorDocumentManagementDialog.tsx
                            for the full writeup) - overridden back to a real fixed-layout table here too. */}
                        <table className={'project-billing'} style={{ display: 'table', tableLayout: 'fixed', width: '100%' }}>
                            <thead style={{ textAlign: 'center' }}>
                                <tr>
                                    <th style={{ width: '2%' }}/>
                                    <th style={{ width: '20%' }}>Description</th>
                                    <th style={{ width: '20%' }}>Date Created</th>
                                    <th style={{ width: '20%' }}>Size</th>
                                    <th style={{ width: '8%' }}>Source</th>
                                    <th style={{ width: '10%' }}>Type</th>
                                    <th style={{ width: '5%' }}/>
                                    <th style={{ width: '5%' }}/>
                                </tr>
                            </thead>
                            <tbody>
                                {!props?.generatingDocument && documentDisplayList && documentDisplayList.length > 0 && displayDocuments()}
                                {props?.generatingDocument && (
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span>Generating Document...</span>
                                        <LoadingSpinner />
                                    </div>
                                )}
                            </tbody>
                        </table>
                        <hr style={{width: '100%', margin: '0', color: '#ccc'}}/>
                        <label>Archived Documents</label>
                        {/* .project-billing's own table CSS sets display:block, which breaks the
                            browser's normal table column-alignment (see VendorDocumentManagementDialog.tsx
                            for the full writeup) - overridden back to a real fixed-layout table here too. */}
                        <table className={'project-billing'} style={{ display: 'table', tableLayout: 'fixed', width: '100%' }}>
                            <thead style={{ textAlign: 'center' }}>
                                <tr>
                                    <th style={{ width: '10%' }}>Description</th>
                                    <th style={{ width: '10%' }}>Date Created</th>
                                    <th style={{ width: '10%' }}>Size</th>
                                    <th style={{ width: '8%' }}>Source</th>
                                    <th style={{ width: '10%' }}>Type</th>
                                    <th style={{ width: '10%' }}>By</th>
                                    <th style={{ width: '10%' }}>Date</th>
                                    <th style={{ width: '10%' }}>Reason</th>
                                    <th style={{ width: '5%' }}/>
                                    <th style={{ width: '5%' }}/>
                                </tr>
                            </thead>
                            <tbody>
                                {props?.archivedDocumentList && props.archivedDocumentList.length > 0 && displayArchivedDocuments()}
                            </tbody>
                        </table>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <Button
                                className="blue-hover-button"
                                style={{ width: '15%', marginRight: '1rem' }}
                                text={'Select all'}
                                onClick={() => handleSelectAll(props?.documentList)}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '15%', marginRight: '1rem' }}
                                text={'Deselect all'}
                                onClick={() => handleDeselectAll()}
                            />
{/*                            <Button
                                className="blue-hover-button"
                                style={{ width: '14%', marginRight: '1rem' }}
                                text={'Create CSV'}
                                onClick={() => props.getBaseCSV(props?.invoiceNumber)}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '14%', marginRight: '1rem' }}
                                text={'Create CSV'}
                                onClick={() => props.getBaseCSV(props?.invoiceNumber)}
                            />
                             <Button
                                className="blue-hover-button"
                                style={{ width: '15%', marginRight: '1rem' }}
                                text={'Create Invoice'}
                                onClick={() => props.createDocument(0, props?.invoiceNumber)}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '12%', marginRight: '1rem' }}
                                text={'Timesheet'}
                                onClick={() => props?.createNewTimesheet()}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '12%', marginRight: '1rem' }}
                                text={'Expense Receipts'}
                                onClick={() => props?.getExpenseReceipts(Number(props?.invoiceNumber))}
                            /> */}
                            <Button
                                className="blue-hover-button"
                                style={{ width: '15%', marginRight: '1rem' }}
                                text={'Add Document'}
                                onClick={() => props?.addDocument()}
                            />
                            <Button
                                className="blue-hover-button"
                                style={{ width: '15%', marginRight: '1rem' }}
                                text={'Merge'}
                                onClick={() => props?.mergeDocuments(selectedDocs, props?.invoiceNumber)}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Close'}
                    onClick={() => OKClicked()}
                />
            </div>
        </Dialog>
    );
};

export default InvoiceDocumentManagementDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/InvoiceDocumentManagementDialog.tsx